var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 531,
    viewBox: "0 0 565 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.13 65.6191L369.425 65.3259V64.9101V1H438.235V93.6913L282.198 249.105L126.421 93.6918V1H195.232V64.9101V65.325L195.525 65.6181L281.491 151.383L282.196 152.086L282.903 151.384L369.13 65.6191Z",
    stroke: "url(#paint0_linear_5957_13815)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.526 465.381L195.232 465.674V466.09V530H126.421V437.309L282.458 282.155L438.235 437.309V530H369.425V466.09V465.675L369.131 465.382L283.165 379.617L282.46 378.914L281.754 379.616L195.526 465.381Z",
    stroke: "url(#paint1_linear_5957_13815)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M498.885 353.145L499.178 353.438H499.592H563.654V421.822H470.741L314.967 266.412L470.741 111.002H563.654V179.387H499.592H499.178L498.885 179.68L412.919 265.706L412.213 266.412L412.919 267.119L498.885 353.145Z",
    stroke: "url(#paint2_linear_5957_13815)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7706 179.681L65.4775 179.387H65.0622H1V111.002H93.9131L249.688 266.672L93.9141 421.822H1V353.438H65.0622H65.4758L65.7685 353.146L151.734 267.381L152.442 266.675L151.736 265.967L65.7706 179.681Z",
    stroke: "url(#paint3_linear_5957_13815)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5957_13815",
    x1: 282.328,
    y1: 0,
    x2: 282.328,
    y2: 250.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0646A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0963EB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5957_13815",
    x1: 282.328,
    y1: 280.744,
    x2: 282.328,
    y2: 531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0646A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0963EB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5957_13815",
    x1: 439.103,
    y1: 110.002,
    x2: 439.103,
    y2: 422.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0646A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0963EB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5957_13815",
    x1: 125.552,
    y1: 110.002,
    x2: 125.552,
    y2: 422.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0646A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0963EB",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.049debd922cedd10217b0168920c09e9.svg";
export { ForwardRef as ReactComponent };